<template>
  <div>
    <b-card>

      <div class="d-flex justify-content-between mb-3">
        <h3>Agent Subscriptions</h3>
        <b-button variant="primary" @click="openCreate">
          Assign Subscription
        </b-button>
      </div>

      <b-table :items="subscriptions" :fields="fields" small responsive>

        <template #cell(agent_data)="row">
          {{ row.item.agent_data && row.item.agent_data.full_name ? row.item.agent_data.full_name : row.item.agent_data || '-' }}
        </template>

        <template #cell(business_phone)="row">
          {{ row.item.agent_data && row.item.agent_data.business_phone ? row.item.agent_data.business_phone : row.item.agent_data || '-' }}
        </template>

        <template #cell(plan_data)="row">
          {{ row.item.plan_data && row.item.plan_data.name ? row.item.plan_data.name : row.item.plan_data || '-' }}
        </template>

        <template #cell(is_active)="row">
          <b-badge :variant="row.item.is_active ? 'success' : 'danger'">
            {{ row.item.is_active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>

        <template #cell(manage)="row">
          <b-button size="sm" variant="info" @click="editSubscription(row.item)">
            Edit
          </b-button>
        </template>

      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        align="right"
        class="mt-3"
      />

    </b-card>

    <CreateAgentSubscriptionModal
      @modalClosed="fetchSubscriptions"
      :key="createKey"
    />

    <EditAgentSubscriptionModal
      :subscription="subscription"
      @modalClosed="fetchSubscriptions"
      :key="editKey"
    />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import CreateAgentSubscriptionModal from "@/components/agent_subscription/CreateAgentSubscriptionModal.vue";
import EditAgentSubscriptionModal from "@/components/agent_subscription/EditAgentSubscriptionModal.vue";

export default {
  components: {
    CreateAgentSubscriptionModal,
    EditAgentSubscriptionModal
  },

  data() {
    return {
      fields: [
        { key: "agent_data", label: "Agent" },
        { key: "business_phone", label: "Business Number" },
        { key: "plan_data", label: "Plan" },
        { key: "start_date", label: "Start Date" },
        { key: "end_date", label: "End Date" },
        { key: "is_active", label: "Status" },
        { key: "manage", label: "Manage" }
      ],
      subscriptions: [],
      currentPage: 1,
      totalItems: 0,
      perPage: 0,
      subscription: null,
      createKey: 0,
      editKey: 0,
    };
  },

  mounted() {
    this.fetchSubscriptions();
  },

  methods: {
    ...mapActions("appData", ["getAgentSubscriptions"]),

    async fetchSubscriptions() {
      const res = await this.getAgentSubscriptions({
        page: this.currentPage
      });

      this.subscriptions = res.data.results;
      this.totalItems = res.data.count;
      this.perPage = res.data.per_page;
    },

    openCreate() {
      this.createKey++;
      this.$nextTick(() =>
        this.$bvModal.show("create-agent-subscription-modal")
      );
    },

    editSubscription(subscription) {
      this.subscription = subscription;
      this.editKey++;
      this.$nextTick(() =>
        this.$bvModal.show("edit-agent-subscription-modal")
      );
    }
  },

  watch: {
    currentPage() {
      this.fetchSubscriptions();
    }
  }
};
</script>